"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var javascript_sdk_1 = require("@mdap/javascript-sdk");
var log_1 = require("@mdap/javascript-sdk/lib/utils/log");
var observer_1 = require("./observer");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var ErrorDataDuplicateType;
(function (ErrorDataDuplicateType) {
    ErrorDataDuplicateType[ErrorDataDuplicateType["REPORT"] = 0] = "REPORT";
    ErrorDataDuplicateType[ErrorDataDuplicateType["DISCARD"] = 1] = "DISCARD";
    ErrorDataDuplicateType[ErrorDataDuplicateType["PATCH"] = 2] = "PATCH";
})(ErrorDataDuplicateType || (ErrorDataDuplicateType = {}));
var ResourcePlugin = /** @class */ (function (_super) {
    __extends(ResourcePlugin, _super);
    function ResourcePlugin(configs) {
        if (configs === void 0) { configs = {}; }
        var _this = _super.call(this, configs) || this;
        _this.type = 'resource';
        /** 为false时，无法监测收集到动态加载的资源信息，需要进行数据补充 */
        _this.supportObserver = true;
        _this.configs = configs;
        return _this;
    }
    ResourcePlugin.prototype.register = function (props) {
        //
        this.triggerHandler = props.trigger;
        this.projectId = props.app_name;
        ResourcePlugin.TRIGGER_MAPS[props.app_name] = {
            match: this.isMatch.bind(this),
            triggerFunciton: props.trigger,
            addErrorData: this.reportErrorData.bind(this)
        };
        this.init();
    };
    ResourcePlugin.prototype.init = function () {
        try {
            this.handleLoadedResource();
            // 初始化兼容性信息
            if (typeof this.addLabels === 'function') {
                this.addLabels({
                    supportObserveType: utils_1.supportObserveType('resource') ? 'true' : 'false',
                    supportGetEntriesByType: constants_1.supportGetEntriesByType ? 'true' : 'false'
                });
            }
            if (ResourcePlugin.filled) {
                return;
            }
            this.observe();
            this.observeError();
        }
        catch (error) {
            log_1.Logger.log('Failed to init mdap resource plugin');
            log_1.Logger.error(error);
        }
    };
    ResourcePlugin.prototype.isMatch = function (url) {
        var _a;
        if (!((_a = this.configs.path) === null || _a === void 0 ? void 0 : _a.length)) {
            return true;
        }
        var match = false;
        for (var _i = 0, _b = this.configs.path; _i < _b.length; _i++) {
            var rule = _b[_i];
            if (url.match(rule)) {
                match = true;
                break;
            }
        }
        return match;
    };
    ResourcePlugin.prototype.processData = function (entry, resourceType) {
        var _a;
        var timeOrigin = this.serverNow(performance.timeOrigin || performance.timing.navigationStart);
        var resourceTimingData = utils_1.processResourceData(entry);
        var pageUrl = "" + window.location.href.slice(0, 512);
        var startTime = Math.round(timeOrigin + entry.startTime);
        return __assign({ url: entry.name, start_timestamp: startTime, end_timestamp: entry.responseEnd > 0 ? Math.round(timeOrigin + entry.responseEnd) : startTime, 
            // mobile safari 下观测到duration可能获取不准确
            duration: Math.max(-1, (_a = Math.round(entry.duration)) !== null && _a !== void 0 ? _a : Math.round(entry.responseEnd - entry.startTime)), page_url: pageUrl, http_method: 'GET', logic_status_code: constants_1.DEFAULT_LOGIC_STATUS_CODE, 
            // TODO - 资源加载失败场景处理
            http_status_code: constants_1.HTTP_STATUS_CODE.SUCCESS, resource_type: resourceType, resource_cache_type: constants_1.UNKNOWN, resource_load_speed: utils_1.getLoadSpeed(entry), resource_query_cache: Math.max(Math.round(entry.domainLookupStart - entry.fetchStart), 0), resource_load_time: Math.max(Math.round(entry.responseEnd - entry.responseStart), 0) }, resourceTimingData);
    };
    ResourcePlugin.prototype.handleEntry = function (entry, from) {
        if (from === void 0) { from = 'observer'; }
        if (!utils_1.isResource(entry)) {
            return;
        }
        // 过滤文件类型
        var resourceType = utils_1.getResourceType(entry.name, entry.initiatorType);
        if (!resourceType) {
            return;
        }
        if (from === 'init') {
            if (this.isMatch(entry.name)) {
                var data = this.processData(entry, resourceType);
                this.triggerHandler(data);
            }
            return;
        }
        // 多实例共用一个observe
        for (var _i = 0, _a = Object.values(ResourcePlugin.TRIGGER_MAPS); _i < _a.length; _i++) {
            var triggerConfig = _a[_i];
            if (triggerConfig.match(entry.name)) {
                var data = this.processData(entry, resourceType);
                triggerConfig.triggerFunciton(data);
            }
        }
    };
    ResourcePlugin.prototype.handleLoadedResource = function () {
        var _this = this;
        if (constants_1.supportGetEntriesByType) {
            performance.getEntriesByType('resource')
                .map(function (entry) {
                _this.handleEntry(entry);
            });
        }
        // Get failed resources
        var presetReource = window.__MDAP_PREV_RESOURCE__;
        if (presetReource === null || presetReource === void 0 ? void 0 : presetReource.data) {
            // Deduplicate
            var datas = utils_1.deduplicateErrorDatas(presetReource.data
                .map(function (item) { return _this.getErrorInfo(item); })
                .filter(Boolean));
            for (var _i = 0, datas_1 = datas; _i < datas_1.length; _i++) {
                var data = datas_1[_i];
                this.reportErrorData(data, data.shouldPatch ? ErrorDataDuplicateType.PATCH : undefined);
            }
            // TODO: 多项目集成， 不能随便移除
            // if (typeof presetReource?.removePrevListener === 'function') {
            //   presetReource.removePrevListener();
            // }
        }
    };
    ResourcePlugin.prototype.observe = function () {
        var _this = this;
        if (utils_1.supportObserveType('resource')) {
            ResourcePlugin.po = new PerformanceObserver(function (list) { return list.getEntries().map(_this.handleEntry.bind(_this)); });
            ResourcePlugin.po.observe({
                entryTypes: ['resource']
            });
            return;
        }
        if (constants_1.supportGetEntriesByType) {
            var ob = new observer_1.DynamicResourceObserver(this.projectId, function (entries) {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    _this.handleEntry(entry);
                }
            });
            ob.observe();
            return;
        }
        this.supportObserver = false;
    };
    ResourcePlugin.prototype.removeObserve = function () {
        if (this.projectId) {
            delete ResourcePlugin.TRIGGER_MAPS[this.projectId];
        }
    };
    ResourcePlugin.prototype.disconnectObserve = function () {
        var _a;
        (_a = ResourcePlugin.po) === null || _a === void 0 ? void 0 : _a.disconnect();
    };
    // 生成资源加载错误的上报数据
    ResourcePlugin.prototype.reportErrorData = function (data, status) {
        if (!this.isMatch(data.src)) {
            return;
        }
        var resourceType = utils_1.getResourceType(data.src, data.initiatorType);
        var timeOrigin = performance.timeOrigin || performance.timing.navigationStart;
        var time = this.serverNow(Math.round(data.timeStamp + timeOrigin));
        var pageUrl = "" + window.location.href.slice(0, 512);
        this.triggerHandler({
            url: data.src,
            http_method: 'GET',
            start_timestamp: time,
            end_timestamp: time,
            duration: 1,
            page_url: pageUrl,
            logic_status_code: constants_1.DEFAULT_LOGIC_STATUS_CODE,
            http_status_code: constants_1.HTTP_STATUS_CODE.FAILED,
            resource_type: resourceType,
            resource_cache_type: constants_1.UNKNOWN,
        });
        var shouldPatchData = status === ErrorDataDuplicateType.PATCH || !utils_1.supportObserveType('resource') && status !== undefined;
        if (shouldPatchData) {
            // 补充上报资源加载信息
            this.triggerHandler({
                url: data.src,
                http_method: 'GET',
                start_timestamp: time,
                end_timestamp: time,
                duration: 1,
                page_url: pageUrl,
                logic_status_code: constants_1.DEFAULT_LOGIC_STATUS_CODE,
                http_status_code: constants_1.HTTP_STATUS_CODE.PATCH,
                resource_type: resourceType,
                resource_cache_type: constants_1.UNKNOWN,
            });
        }
    };
    ResourcePlugin.prototype.getErrorInfo = function (evt) {
        // 判断是否为资源加载类错误
        if (utils_1.isLinkElement(evt.target)) {
            return {
                src: evt.target.href,
                timeStamp: evt.timeStamp,
                initiatorType: evt.target.localName
            };
        }
        if (utils_1.isSrcElement(evt.target)) {
            return {
                src: evt.target.src,
                timeStamp: evt.timeStamp,
                initiatorType: evt.target.localName
            };
        }
        return undefined;
    };
    /* Check if data is duplicated with reported datas */
    ResourcePlugin.prototype.checkDuplicateData = function (data) {
        var _a;
        // check buffer
        var shouldDiscardFirstItem = ResourcePlugin.errorResources.length >= constants_1.BUFFER_DATA_LIMIT
            || performance.now() - ((_a = ResourcePlugin.errorResources[0]) === null || _a === void 0 ? void 0 : _a.timeStamp) >= constants_1.BUFFER_DATA_TIMEOUT;
        if (shouldDiscardFirstItem) {
            ResourcePlugin.errorResources.shift();
        }
        var identicalResources = ResourcePlugin.errorResources.filter(function (resource) { return data.src === resource.src
            && data.timeStamp - resource.timeStamp < constants_1.ERROR_RESOURCE_DUPLICATE_TIMELIMIT; });
        if (!identicalResources || !this.supportObserver) {
            ResourcePlugin.errorResources.push(data);
            return ErrorDataDuplicateType.REPORT;
        }
        if (constants_1.supportGetEntriesByType) {
            // Check with performance API for sure
            var obtainedResources = performance.getEntriesByType('resource')
                .filter(function (entry) { return entry.name === data.src; });
            /**
             * Compatibility - some browser cannot get failed resource from performance getEntries
             */
            if (obtainedResources.length <= 0) {
                return ErrorDataDuplicateType.PATCH;
            }
            if (identicalResources.length >= obtainedResources.length) {
                // duplicated data, abort
                return ErrorDataDuplicateType.DISCARD;
            }
        }
        ResourcePlugin.errorResources.push(data);
        return ErrorDataDuplicateType.REPORT;
    };
    ResourcePlugin.prototype.handleError = function (evt) {
        try {
            var data = this.getErrorInfo(evt);
            if (!data) {
                return false;
            }
            var checkStatus = this.checkDuplicateData(data);
            if (checkStatus === ErrorDataDuplicateType.DISCARD) {
                return false;
            }
            for (var _i = 0, _a = Object.values(ResourcePlugin.TRIGGER_MAPS); _i < _a.length; _i++) {
                var triggerConfig = _a[_i];
                if (triggerConfig.match(data.src)) {
                    triggerConfig.addErrorData(data, checkStatus);
                }
            }
            return true;
        }
        catch (error) {
            // 
            console.trace(error);
        }
    };
    ResourcePlugin.prototype.observeError = function () {
        var _this = this;
        window.addEventListener('error', function (evt) {
            _this.handleError(evt);
            return false;
        }, true);
    };
    ResourcePlugin.prototype.sendData = function (data) {
        if (typeof this.triggerHandler !== 'function') {
            log_1.Logger.log('[MDAP] resource plugin is inactive');
            return;
        }
        if (!data.url) {
            log_1.Logger.info('[MDAP] URL cannot be empty');
            return;
        }
        if (typeof data.duration !== 'number') {
            log_1.Logger.info('[MDAP] Duration should be number.');
            return;
        }
        var defaultValue = {
            resource_cache_type: constants_1.UNKNOWN,
            http_status_code: 200,
            http_method: 'GET',
            logic_status_code: constants_1.DEFAULT_LOGIC_STATUS_CODE,
            end_timestamp: this.serverNow(),
            start_timestamp: this.serverNow() - data.duration
        };
        if (!data.resource_type) {
            defaultValue.resource_type = utils_1.getResourceType(data.url, constants_1.UNKNOWN);
            if (!defaultValue.resource_type) {
                log_1.Logger.info("[MDAP] Unsupported resource type. " + data.url);
                return;
            }
        }
        this.triggerHandler(__assign(__assign({}, defaultValue), data));
    };
    ResourcePlugin.TRIGGER_MAPS = {};
    ResourcePlugin.filled = false;
    ResourcePlugin.errorResources = [];
    return ResourcePlugin;
}(javascript_sdk_1.BasePlugin));
exports.default = ResourcePlugin;
